import React, { useState } from 'react';

import ProgressBar from '../ProgressBar/ProgressBar';
import SelectList from './SelectList';
import ImportantNote from './ImportantNote';

import styles from './Steps.module.css';

export const shareMealsLabels = [
  {
    label: 'No',
    value: 'no',
  },
  {
    label: 'Yes, with partner/flatmate',
    value: 'parent',
  },
  {
    label: 'Yes, with my children',
    value: 'children',
  },
  {
    label: 'Yes, with my partner and children',
    value: 'parent_and_children',
  },
];

const Step13 = (props) => {
  const { onSave, stepsData } = props;

  const [shareMeals, setShareMeals] = useState(stepsData.share_meals);
  const [showNote, setShowNote] = useState(false);
    

  const onFinishSave = (shareMeals) => {
    onSave({ share_meals: shareMeals });
  };

  const onSaveHandler = (shareMeals) => {
    if (shareMeals !== 'no') {
      setShareMeals(shareMeals);
      setShowNote(true);
      return;
    }
    onFinishSave(shareMeals);
  };

  if (showNote) {
    return (
      <ImportantNote
        className={styles.shareMealsImportantNote}
        message="Meal plans for multiple people will be available soon in the next versions of the App."
        onClick={() => onFinishSave(shareMeals)}
      />
    );
  }

  return (
    <div className={styles.stepWrapper}>
      <ProgressBar onSave={onSave} />
      <div className={styles.shareMealsContent}>
        <div className={styles.stepHeader}>
          Do you share your meals with your household?
        </div>
        <SelectList  
          defaultValue={shareMeals}
          onChange={onSaveHandler}
          options={shareMealsLabels}
        />
      </div>
    </div>
  );
};

export default Step13;